import { useContext } from 'react';

import {
  LANGUAGE_DEFAULT,
  LANGUAGE_LOCALE_DEFAULT,
} from 'src/app/shared/constants/language';
import { SITE_DEFAULT } from 'src/app/shared/constants/site';
import { AppConfigContext } from 'src/app/shared/contexts/configProvider';

export const useConfig = () => {
  const { language, locale, site } = useContext(AppConfigContext);

  const getLanguage = (defaultValue = LANGUAGE_DEFAULT) =>
    language || defaultValue;
  const getLocale = (defaultValue = LANGUAGE_LOCALE_DEFAULT) =>
    locale || defaultValue;
  const getSite = (defaultValue = SITE_DEFAULT) => site || defaultValue;

  return { getLanguage, getLocale, getSite };
};
